import { createPosition } from "@shared/common/utils/create";
import shortUUID from "short-uuid";
import type { IFormHiddenFieldNode, PartialNode } from "../type";

const createFormHiddenFieldNode = (
  data?: PartialNode<IFormHiddenFieldNode>
): IFormHiddenFieldNode => {
  return {
    type: "FORM_HIDDEN_FIELD",
    id: shortUUID.generate(),
    pluginData: {
      contentEditorPropSeq: 0,
      contentMeta: [],
    },
    reactions: [],
    position: createPosition(data?.position),

    name: "",

    width: { value: 100, unit: "%" },

    fills: [],

    locked: false,

    strokes: [],
    strokeWeight: 1,
    strokeAlign: "CENTER",
    strokeCap: "SQUARE",
    strokeJoin: "ROUND",
    dashPattern: [],

    visible: true,

    effects: [],

    label: "<p>히든 필드</p>",
    required: false,
    fields: [],

    ...data,
  };
};

export default createFormHiddenFieldNode;
